import { gql } from 'apollo-boost'

const APPROVE_MENUS_FROM_ADVANCED_PROBING_SESSION = gql`
  mutation approveMenusFromAdvancedProbingSession($id: ID!) {
    approveMenusFromAdvancedProbingSession(id: $id) {
      id
      approvedCount
      clustersProcessed
    }
  }
`

export default APPROVE_MENUS_FROM_ADVANCED_PROBING_SESSION
